import React from 'react';

import BlockAccessPage from '../../../../../components/BlockAccess/BlockAccessPage';
import {checkIfHasPermissions} from '../../../../../components/Menu/Utils/commonFunctions';
import DceTable from '../../../../../components/Table/DceTable';
import FafTable from '../../../../../components/Table/FafTable';
import GhTable from '../../../../../components/Table/GhTable';
import Tabs from '../../../../../components/Tabs/Tabs';
import {PermissionEnum} from '../../../../../constants/permissionsEnum';
import TranslatedText from '../../../../../libraries/I18N/TranslatedText';
import {accessModule} from '../../../../../store/companyStore/companyDetailsStore';
import {shouldBlockModuleAccess} from '../../../../../utils/SubscriptionHelper';

const SoldProducts: React.FC<{
  selectedYear: string;
}> = ({selectedYear}) => {
  const B2bTabs = [
    {
      id: 'dce',
      name: <TranslatedText translationKey="Directly Consume Energy" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <DceTable selectedYear={selectedYear} />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerProductUseOfSoldProductsDCE
      )
    },
    {
      id: 'faf',
      name: <TranslatedText translationKey="Fuels and Feedstocks" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <FafTable selectedYear={selectedYear} />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerProductUseOfSoldProductsFuelsAndFeedstocks
      )
    },
    {
      id: 'ggc',
      name: <TranslatedText translationKey="Greenhouse Gases Contained" />,
      component: shouldBlockModuleAccess(accessModule.scope3) ? (
        <BlockAccessPage />
      ) : (
        <GhTable selectedYear={selectedYear} />
      ),
      hidden: !checkIfHasPermissions(
        PermissionEnum.OrgManagerProductUseOfSoldProductsGGC
      )
    }
  ].filter((item) => !item.hidden);

  return <Tabs array={B2bTabs} type="card" />;
};

export default SoldProducts;
